<script setup>
    
    import { tagsFilterHandles } from '~~/shared/utilities/catalog/map.utils';
    
    const props = defineProps({
        session: {
            type: Object,
            required: true
        },
        tags: {
            type: Array,
            required: true
        }
    });

    // 2026 sessions (from Sessionboard) live at /agenda; pre-2026 sessions
    // use the legacy /2025-sessions archive.
    const tagsUrl = computed(() => (props.session?.year === 2026 ? '/agenda' : '/2025-sessions'));

    const handleTagClick = (handle, tag) => {
        navigateTo(`${tagsUrl.value}?tags=${tag.id}#grid`);
    };

</script>
<template>
    <div class="session-tags-list tags">
        <template v-for="(handle, key) in tagsFilterHandles" :key="handle">
            <template v-if="session[handle] && session[handle].length > 0">
                <MessLink v-for="tag in session[handle]" :key="tag.id" :href="`${tagsUrl}?tags=${tag.id}`" :label="tag.name">
                    <ProjectTag colorSet="meteor-transparent" :key="tag.id" :text="tag.name" :useHover="true" :useX="false" @click.prevent="handleTagClick(handle, tag)" :gtmEventName="'session_tag_clicked'" />
                </MessLink>
            </template>
        </template>
    </div>
</template>

<style>
.session-tags-list.tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 8px;
}

.session-tags-list.tags .project-tag,
.session-tags-list.tags .project-tag p {
    color: var(--magenta);
    border-radius: 9999px;
    background: transparent;
    font-family: var(--font-hubspot-sans);
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    letter-spacing: 0.24px;
    text-decoration: none;
    text-transform: none;
}

.session-tags-list.tags .project-tag {
    border: 1px solid var(--magenta);
    padding: 0 10px;
}

.session-tags-list.tags .project-tag:hover,
.session-tags-list.tags .project-tag:focus {
    color: white;
    background: var(--magenta);
}

.session-tags-list.tags .project-tag:hover p,
.session-tags-list.tags .project-tag:focus p {
    color: white;
}

/* The 2026 session-detail/tray type+theme pills (colorSet="session-tag") use the
   baseline magenta (#46062B) above — no override. The dark-pink #7D4566 now lives
   on the single session-type eyebrow pill instead (see header.vue / drawer). */
</style>